// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"31d6cfe0","267":"6e352145","396":"8752e84c","407":"f4b1d673","509":"9498e3d7","552":"84026828","599":"738c22e3","966":"496fbf0f"}[chunkId] + ".chunk.css";
};